import { Vue } from '@_src/common/core/common';
import storeFactory from '@_src/common/store';
import store from './store';
import index from './index.vue';

index.store = storeFactory(store);
index.mpType = 'app';

const app = new Vue(index);
app.$mount('#root');
